/**
 * Énumérations du domaine ferry — `const X = {} as const` (pas `enum` TS).
 *
 * Avantages vs `enum` :
 *   - Zéro JS généré au bundle (les `enum` créent un objet runtime)
 *   - Tree-shakeable
 *   - Strict type-narrowing avec `as const`
 *   - Compatible avec les payloads backend qui utilisent les valeurs string
 *
 * Convention : pour chaque énumération, on exporte AUSSI le type union
 * (`type Direction = typeof Direction[keyof typeof Direction]`).
 */

/**
 * Direction de voyage. Aligné STRICTEMENT sur le backend (PHP
 * `App\Enum\Ferry\Direction` : `Outward` | `Return` ; validation
 * AvailabilityOutput `choices => ['Outward','Return']`). Le « combiné » A/R
 * n'existe qu'au niveau ticket sous la string `'Outward+Return'`, jamais comme
 * direction de recherche — d'où l'absence de `Both` (invention front, morte au
 * runtime).
 */
export const Direction = {
  Outward: 'Outward',
  Return: 'Return',
} as const
export type Direction = typeof Direction[keyof typeof Direction]

/** Types de passager. */
export const PassengerType = {
  Adult: 'Adult',
  Child: 'Child',
  Baby: 'Baby',
} as const
export type PassengerType = typeof PassengerType[keyof typeof PassengerType]

/** Genre du passager — requis par certains providers ferry. */
export const Gender = {
  Male: 'Male',
  Female: 'Female',
} as const
export type Gender = typeof Gender[keyof typeof Gender]

/** Étapes du funnel booking. Drive la state machine `BookingFlow`. */
export const BookingStep = {
  Search: 'search',
  Results: 'results',
  Options: 'options',
  Booking: 'booking',
  Confirmation: 'confirmation',
} as const
export type BookingStep = typeof BookingStep[keyof typeof BookingStep]

/**
 * État haut niveau du booking — utilisé par les composables pour driver
 * les transitions et les UI loading/error/empty.
 */
export const BookingState = {
  Searching: 'searching',
  TicketsSelected: 'tickets_selected',
  SelectingPlaces: 'selecting_places',
  Ready: 'ready',
  Booking: 'booking',
  Completed: 'completed',
} as const
export type BookingState = typeof BookingState[keyof typeof BookingState]

/** Type de tarif retourné par les providers. */
export const TariffType = {
  Ticket: 'ticket',
  Presale: 'presale',
  Option: 'option',
} as const
export type TariffType = typeof TariffType[keyof typeof TariffType]

/** Groupe d'installations (places assises / cabines) — limite provider. */
export const GroupType = {
  Group1: 'group1',
  Group2: 'group2',
} as const
export type GroupType = typeof GroupType[keyof typeof GroupType]
